import { HttpClient } from '@angular/common/http';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

export abstract class EditService<TEntity, TFilter> extends ReadService<TEntity, TFilter> {
  // public url: string;
  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public create(item: TEntity): Promise<TEntity> {
    return this.handleRequest(
      this.http.post(`${this.url}`, item),
      this.handlersFactory.getForCreate(this.entityTitle),
    ).then(this.extractData);
  }

  public update(id: number | string, item: TEntity): Promise<TEntity> {
    return this.handleRequest(
      this.http.put(`${this.url}/${id}`, item),
      this.handlersFactory.getForUpdate(this.entityTitle),
    ).then(this.extractData);
  }

  public delete(id: number | string): Promise<any> {
    return this.handleRequest(
      this.http.delete(`${this.url}/${id}`),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }
}
